export default __webpack_public_path__ + "static/media/hobby.5408328d.svg";